import './Loader.css'

const Loader = () => {
    return (
        <div className="loading"></div>
    )
}

export default Loader
